// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get, map, includes, size, forEach } from 'lodash'
import { Button, Tabs, Icon, Dropdown, Menu } from 'antd'

// Onglets
import { Information, PermitsTab } from './Tabs'

// Styles
import './Styles/Single.less'
import {
  CapacityFormSpecs,
  CleanFormSpecs,
  FireFormSpecs,
  SearchFormSpecs
} from 'Views/Permits/Specs'
import {
  getTabKeyFromParams,
  updateUrlTabParam
} from 'Services/permitUrlParams'
import { SUBPERMIT_TYPES } from 'Config/config'
import Loader from 'Components/Loader/Loader'

const { TabPane } = Tabs

class PermitSingle extends Component {
  static propTypes = {
    // Témoin d'approvisionnement des données
    loading: PropTypes.bool,
    isSubPermitLoading: PropTypes.bool,
    isDownloading: PropTypes.bool,

    // Utilisateur connecté
    profile: PropTypes.object,

    // Navigation
    navigation: PropTypes.object,

    // Données de la vue
    data: PropTypes.object,

    // Structure de la formLayout
    FormSpecs: PropTypes.object,

    onValuesChange: PropTypes.func,

    // Fonctions hérités du constructeur
    constructorFunctions: PropTypes.objectOf(PropTypes.func)
  }

  static defaultProps = {
    // Témoin d'approvisionnement des données
    loading: true,
    isDownloading: false,

    // Données de la vue
    data: {},

    // Structure de la formLayout
    FormSpecs: {}
  }

  constructor(props) {
    super(props)

    this.state = {
      openedModal: '',
      previewImage: '',
      fileSingle: [],
      firePermit: null,
      searchPermit: null,
      capacityPermit: null,
      cleaningPermit: null,
      activeTab: 'information'
    }
  }

  componentDidMount = () => {
    // Lecteur de fichier
    this.fileReader = new FileReader()

    this.props.constructorFunctions.setCloseInformation(this.closeInformation)
  }

  componentDidUpdate(prevProps) {
    // Detect if main permit has changed to update the sub permit (after actions like "sign" etc.)
    const prevMainPermit = prevProps.data
    if (this.isMainPermitChanged(prevMainPermit, this.props.data)) {
      this.updateSubPermitOnActiveCategory(prevMainPermit)
    }

    // In some scenarios (ex: After sub-permit creation), we need to reset the current tab to show the loader
    const permitLost = !!prevProps?.data.id && !this.props.data?.id
    if (permitLost) {
      this.resetCurrentTab()
    }

    // When permit is retrieved, we need to select the initial tab if any provided in the url
    const permitRetrieved = !prevProps?.data.id && !!this.props.data?.id
    if (permitRetrieved) {
      this.selectInitialTab()
    }
  }

  closeInformation = () => {
    this.setState({
      firePermit: null,
      searchPermit: null,
      capacityPermit: null,
      cleaningPermit: null
    })
  }

  resetCurrentTab = () => {
    this.setState({
      activeTab: 'information'
    })
  }

  handleTabClick = key => {
    const { activeTab } = this.state
    if (activeTab === key) {
      switch (key) {
        case 'firePermits':
          this.setState({ firePermit: null })
          break
        case 'searchPermits':
          this.setState({ searchPermit: null })
          break

        case 'capacityPermits':
          this.setState({ capacityPermit: null })
          break

        case 'cleaningPermits':
          this.setState({ cleaningPermit: null })
          break

        default:
          this.setState({ activeTab: 'information' })
      }
    }
  }

  renderTabs = () => {
    const { activeTab } = this.state
    const {
      data: permit,
      constructorFunctions,
      navigation,
      FormSpecs,
      profile,
      loading,
      isSubPermitLoading,
      isDownloading,
      onValuesChange
    } = this.props

    // Peut contenir un permis feu ?
    const isFirePermitAllowed =
      includes(
        map(get(permit, 'associatedPermits'), 'name'),
        'Permis de feu'
      ) && get(permit, 'status') !== 'requested'

    const isSearchPermitAllowed =
      includes(
        map(get(permit, 'associatedPermits'), 'name'),
        'Permis de fouille'
      ) && get(permit, 'status') !== 'requested'

    const isCapacityPermitAllowed =
      includes(
        map(get(permit, 'associatedPermits'), 'name'),
        'Permis de travailler dans un endroit confiné (capacité)'
      ) && get(permit, 'status') !== 'requested'

    const isCleaningPermitAllowed =
      includes(
        map(get(permit, 'associatedPermits'), 'name'),
        'Permis de nettoyage'
      ) && get(permit, 'status') !== 'requested'

    const isUserReader = includes(map(get(profile, 'roles'), 'name'), 'READER')
    const isUserExtern =
      includes(map(get(profile, 'roles'), 'name'), 'EXTERN_READER') ||
      includes(map(get(profile, 'roles'), 'name'), 'EXTERN_CREATOR')

    // const { activeTab } = this.state

    return (
      <Tabs
        className='permit-list'
        defaultActiveKey='information'
        type='card'
        activeKey={activeTab}
        onChange={value => {
          this.setState({ activeTab: value })
          get(constructorFunctions, 'setCurrentSubPermitId')(null)
          if (value === 'firePermits') this.setState({ firePermit: null })
          if (value === 'searchPermits') this.setState({ searchPermit: null })
          if (value === 'capacityPermits')
            this.setState({ capacityPermit: null })
          if (value === 'cleaningPermits')
            this.setState({ cleaningPermit: null })

          updateUrlTabParam(value)
        }}
        onTabClick={this.handleTabClick}
        tabBarExtraContent={
          !isUserReader &&
          !isUserExtern &&
          (isSearchPermitAllowed ||
            isFirePermitAllowed ||
            isCapacityPermitAllowed ||
            isCleaningPermitAllowed) &&
          includes(
            ['waiting', 'opened', 'finished'],
            get(permit, 'status')
          ) && (
            <Dropdown
              placement='bottomRight'
              trigger={['click']}
              overlay={
                <Menu>
                  {isFirePermitAllowed && (
                    <Menu.Item>
                      <Button
                        type='link'
                        onClick={get(
                          constructorFunctions,
                          'askCreateFirePermit'
                        )}
                      >
                        {I18n.t('pages.permits.actions.add.firePermit')}
                      </Button>
                    </Menu.Item>
                  )}
                  {isSearchPermitAllowed && (
                    <Menu.Item>
                      <Button
                        type='link'
                        onClick={get(
                          constructorFunctions,
                          'askCreateSearchPermit'
                        )}
                      >
                        {I18n.t('pages.permits.actions.add.searchPermit')}
                      </Button>
                    </Menu.Item>
                  )}
                  {isCleaningPermitAllowed && (
                    <Menu.Item>
                      <Button
                        type='link'
                        onClick={get(
                          constructorFunctions,
                          'askCreateCleaningPermit'
                        )}
                      >
                        {I18n.t('pages.permits.actions.add.cleaningPermit')}
                      </Button>
                    </Menu.Item>
                  )}
                  {isCapacityPermitAllowed && (
                    <Menu.Item>
                      <Button
                        type='link'
                        onClick={get(
                          constructorFunctions,
                          'askCreateCapacityPermit'
                        )}
                      >
                        {I18n.t('pages.permits.actions.add.capacityPermit')}
                      </Button>
                    </Menu.Item>
                  )}
                </Menu>
              }
            >
              <Button icon='plus'>
                {I18n.t('pages.permits.actions.add.permit')}
              </Button>
            </Dropdown>
          )
        }
      >
        {/* Informations */}
        <TabPane
          tab={
            <span className={`permit permit-${get(permit, 'status')}`}>
              {I18n.t('pages.permits.tabs.information.title')}
            </span>
          }
          key='information'
        >
          {loading ? (
            <Loader />
          ) : (
            <Information
              data={permit}
              navigation={navigation}
              profile={profile}
              loading={loading}
              isDownloading={isDownloading}
              constructorFunctions={constructorFunctions}
              formLayout={FormSpecs}
              onValuesChange={onValuesChange}
            />
          )}
        </TabPane>

        {/* Permis de feu */}
        {isFirePermitAllowed && (
          <TabPane
            tab={
              <span className={`permit`}>
                <Icon type='fire' />
                {I18n.t('pages.permits.tabs.firePermit.title', {
                  ...permit,
                  total: size(get(permit, 'firePermits'))
                })}
              </span>
            }
            key='firePermits'
          >
            {loading ? (
              <Loader />
            ) : (
              <PermitsTab
                loading={loading}
                isSubPermitLoading={isSubPermitLoading}
                permits={get(permit, 'firePermits')}
                totalPermits={size(get(permit, 'firePermits'))}
                isDownloading={isDownloading}
                openedPermit={this.state.firePermit}
                onPermitChange={permit => {
                  this.setState({ firePermit: permit })
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                onActionDropDownOpen={permit => {
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                type='firePermit'
                formLayout={FireFormSpecs}
                constructorFunctions={constructorFunctions}
                profile={profile}
                closeInformation={this.closeInformation}
              />
            )}
          </TabPane>
        )}

        {/* Permis de fouille */}
        {isSearchPermitAllowed && (
          <TabPane
            tab={
              <span className={`permit`}>
                <Icon type='search' />
                {I18n.t('pages.permits.tabs.searchPermit.title', {
                  ...permit,
                  total: size(get(permit, 'searchPermits'))
                })}
              </span>
            }
            key='searchPermits'
          >
            {loading ? (
              <Loader />
            ) : (
              <PermitsTab
                loading={loading}
                isSubPermitLoading={isSubPermitLoading}
                permits={get(permit, 'searchPermits')}
                totalPermits={size(get(permit, 'searchPermits'))}
                isDownloading={isDownloading}
                openedPermit={this.state.searchPermit}
                onPermitChange={permit => {
                  this.setState({ searchPermit: permit })
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                onActionDropDownOpen={permit => {
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                type='searchPermit'
                formLayout={SearchFormSpecs}
                constructorFunctions={constructorFunctions}
                profile={profile}
                closeInformation={this.closeInformation}
              />
            )}
          </TabPane>
        )}

        {/* Permis de nettoyage */}
        {isCleaningPermitAllowed && (
          <TabPane
            tab={
              <span className={`permit`}>
                <Icon type='delete' />
                {I18n.t('pages.permits.tabs.cleaningPermit.title', {
                  ...permit,
                  total: size(get(permit, 'cleaningPermits'))
                })}
              </span>
            }
            key='cleaningPermits'
          >
            {loading ? (
              <Loader />
            ) : (
              <PermitsTab
                loading={loading}
                isSubPermitLoading={isSubPermitLoading}
                permits={get(permit, 'cleaningPermits')}
                totalPermits={size(get(permit, 'cleaningPermits'))}
                isDownloading={isDownloading}
                openedPermit={this.state.cleaningPermit}
                onPermitChange={permit => {
                  this.setState({ cleaningPermit: permit })
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                onActionDropDownOpen={permit => {
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                type='cleaningPermit'
                formLayout={CleanFormSpecs}
                constructorFunctions={constructorFunctions}
                profile={profile}
                closeInformation={this.closeInformation}
              />
            )}
          </TabPane>
        )}

        {/* Permis de capacité */}
        {isCapacityPermitAllowed && (
          <TabPane
            tab={
              <span className={`permit`}>
                <Icon type='carry-out' />
                {I18n.t('pages.permits.tabs.capacityPermit.title', {
                  ...permit,
                  total: size(get(permit, 'capacityPermits'))
                })}
              </span>
            }
            key='capacityPermits'
          >
            {loading ? (
              <Loader />
            ) : (
              <PermitsTab
                loading={loading}
                isSubPermitLoading={isSubPermitLoading}
                permits={get(permit, 'capacityPermits')}
                totalPermits={size(get(permit, 'capacityPermits'))}
                isDownloading={isDownloading}
                openedPermit={this.state.capacityPermit}
                onPermitChange={permit => {
                  this.setState({ capacityPermit: permit })
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                onActionDropDownOpen={permit => {
                  get(constructorFunctions, 'setCurrentSubPermitId')(permit.id)
                }}
                type='capacityPermit'
                formLayout={CapacityFormSpecs}
                constructorFunctions={constructorFunctions}
                profile={profile}
                closeInformation={this.closeInformation}
              />
            )}
          </TabPane>
        )}
      </Tabs>
    )
  }

  isMainPermitChanged = prevMainPermit => {
    const mainPermit = this.props.data

    const mainPermitChanged =
      !!mainPermit?.id &&
      JSON.stringify(prevMainPermit) !== JSON.stringify(mainPermit)
    const isSubPermitTabActive = this.state.activeTab !== 'information'

    return mainPermitChanged && isSubPermitTabActive
  }

  /**
   * Updates the sub-permit state (on the currently active category tab) after a action (like "sign").
   * This function identifies the sub-permit that was updated in the active category tab
   * and updates the corresponding state key with the new sub-permit.
   */
  updateSubPermitOnActiveCategory = () => {
    const debug = process.env.NODE_ENV === 'development' && true

    const { constructorFunctions, data: mainPermit } = this.props
    const subPermitType = this.state.activeTab

    const subPermitStateKey = {
      [SUBPERMIT_TYPES.FIRE]: 'firePermit',
      [SUBPERMIT_TYPES.SEARCH]: 'searchPermit',
      [SUBPERMIT_TYPES.CLEANING]: 'cleaningPermit',
      [SUBPERMIT_TYPES.CAPACITY]: 'capacityPermit'
    }[subPermitType]

    // Find the permit that was updated in the active category tab
    let permitUpdatedOnActiveCategory = null

    if (debug) {
      console.log('  ')
      console.log('updateSubPermitOnActiveCategory')
      console.log('subPermitType', subPermitType)
      console.log('subPermitStateKey', subPermitStateKey)
      console.log('mainPermit[subPermitType]', mainPermit[subPermitType])
      console.log(
        'this.state[subPermitStateKey]',
        this.state[subPermitStateKey]
      )
    }

    forEach(mainPermit[subPermitType], permit => {
      if (permit.id === this.state[subPermitStateKey]?.id) {
        permitUpdatedOnActiveCategory = permit
      }
    })

    debug &&
      console.log(
        'permitUpdatedOnActiveCategory',
        permitUpdatedOnActiveCategory
      )

    if (permitUpdatedOnActiveCategory) {
      debug && console.log('updateSubPermitOnActiveCategory => updated permit')
      this.setState({ [subPermitStateKey]: permitUpdatedOnActiveCategory })
      get(constructorFunctions, 'setCurrentSubPermitId')(
        permitUpdatedOnActiveCategory.id
      )
    } else {
      debug && console.log('updateSubPermitOnActiveCategory => no permit found')
    }
  }

  selectInitialTab = () => {
    const { constructorFunctions } = this.props

    const subPermitTabKey = getTabKeyFromParams()
    if (subPermitTabKey) {
      console.warn('subPermitTabKey', subPermitTabKey)
      this.setState({ activeTab: subPermitTabKey })
      get(constructorFunctions, 'setCurrentSubPermitId')
    }
  }

  render() {
    return (
      <main className='screen permits permits-single'>
        {/* Données ordonnées en onglets */}
        {this.renderTabs()}
      </main>
    )
  }
}

export default PermitSingle
